export default "__VITE_ASSET__da86bfaa__"